import { gql } from '@apollo/client'

const DISH_CHOICE_INGREDIENT_FRAGMENT = gql`
  fragment DishChoiceIngredientFragment on DishChoiceIngredient {
    ingredient {
      id
      name
      isCurationEnabled
    }
    originField
    word
    matchType
    isSuggestedByAi
    alternativeType
    replacesIngredientId
    usedFeature
    posIndex
    isSuggestedUsingMl
    isSuggestedUsingParser
    mlScore
    isDiscrepancyAccepted
    alreadyFoundIn {
      word
      originField
      posIndex
      matchType
      usedFeature
    }
  }
`
export default DISH_CHOICE_INGREDIENT_FRAGMENT
